import { Button } from '@cian/ui-kit';
import * as React from 'react';

import styles from './FeedbackBlock.css';
import { FeedbackModal } from './FeedbackModal/FeedbackModal';
import { closeIcon } from './close_icon';
import { IFeedbackProps } from '../../containers/Feedback';
import { trackOpenFeedbackForm } from '../../tracking';
import { MODERATION_STATUS_TYPES } from '../../types';

interface IFeedbackState {
  isModalVisible: boolean;
}

export class FeedbackBlock extends React.Component<IFeedbackProps, IFeedbackState> {
  public state = {
    isModalVisible: false,
  };

  public render() {
    const { isModalVisible } = this.state;
    const { feedbackBannerClosed, sendFeedbackAction, showFeedback, builderStatus } = this.props;

    if (!showFeedback || builderStatus === MODERATION_STATUS_TYPES.Published) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>
          <span className={styles['title-head']}>Владелец посёлка?</span>
          <span className={styles['title-text']}>Разместите его на ЦИАН</span>
        </div>
        <div className={styles['icons']}>
          <span className={styles['close-btn']} onClick={feedbackBannerClosed}>
            {closeIcon}
          </span>
          <span className={styles['house-icon']} />
        </div>
        <Button size="XS" onClick={this.handleModalOpening} type="button">
          Добавить посёлок
        </Button>
        <FeedbackModal
          open={isModalVisible}
          onModalClose={() => this.setState({ isModalVisible: false })}
          sendFeedbackAction={sendFeedbackAction}
        />
      </div>
    );
  }

  private handleModalOpening = () => {
    this.setState({
      isModalVisible: true,
    });
    trackOpenFeedbackForm();
  };
}
